import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getForumThreads = (topicId, pageNum, pageSize) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.FORUM_AREA.FORUM_THREADS(topicId, pageNum, pageSize)
  );
};

export default getForumThreads;
